import React, { PropTypes, Component } from 'react'
import moment from 'moment-timezone'

import { Link, Redirect } from 'react-router'

import "./SearchAvailabilityCalendar.scss"

import Loader from 'components/Loader'

import { formatDate } from "utils/dates"
import { aliadas } from '@src/services/api'

import * as fromBookingSetup from '@src/redux/modules/bookingSetup'
import * as qs from 'utils/querystring'
import * as paths from 'utils/paths'

class SearchAvailabilityCalendar extends Component {
  constructor (props) {
    super(props)

    this.state = {
      fetchingAvailability: true,
      calendarEntries: []
    }
  }

  componentDidMount () {
    this.fetchAvailability()
  }

  fetchAvailability () {
    const { searchProps } = this.props

    const initDate = searchProps.date
    const termDate = formatDate('YYYY-MM-DD', moment(initDate).add(2, 'days'))

    const queryString = qs.stringify({...searchProps, initDate: initDate, termDate: termDate})

    aliadas.availability(queryString).then((results)=> {
      const entries = results.map((e) => e.datetime).reduce((acc, datetime) => {
        const date = formatDate('YYYY-MM-DD', datetime)
        const time = formatDate('HH:00', datetime)

        if (!(date in acc)) {
          acc[date] = []
        }

        acc[date].push(time)

        return acc
      }, new Object)

      this.setState({calendarEntries: entries, fetchingAvailability: false})
    })
  }

  render () {
    const { fetchingAvailability } = this.state

    if (fetchingAvailability) {
      return (
        <div className="availability-calendar-loader">
          <p>
            Estamos buscando otros horarios con disponibilitad ...
          </p>

          <Loader text="Buscando ..."/>
        </div>
      )
    }
    return(
      <div className="availability-calendar">
        <p>
          Te mostramos los siguientes días con disponibilidad:
        </p>

        <div className="availability-calendar-page">
          <div className="page">
            { this.calendarDays() }
          </div>
        </div>
      </div>
    );
  }

  calendarDays () {
    const { searchProps }     = this.props
    const { calendarEntries } = this.state

    const days = Object.keys(calendarEntries).map((date) => {
      const hours = calendarEntries[date].map((hour) => {
        const searchData  = {...searchProps, time: hour, date: date}
        const queryString = qs.stringify(searchData)

        return (
          <Link to={ paths.aliadaSearch(queryString) } className='availability-calendar-link'>
            <button className='availability-calendar-timeslot'>
              { hour }
            </button>
          </Link>
        )
      })

      return (
        <div className='availability-calendar-day'>
          <p className='label'>
            { formatDate("ddd D", date) }
          </p>

          <div className='availability-calendar-page-entry'>
            { hours }
          </div>
        </div>
      )
    });

    return days
  }
}

export default SearchAvailabilityCalendar



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Search/components/SearchResults/components/SearchAvailabilityCalendar/SearchAvailabilityCalendar.js